var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"0 15px"},on:{"click":_vm.toggleClick}},[_c('font-awesome-icon',{staticClass:"hamburger",class:{'is-active':_vm.isActive},attrs:{"icon":['far', 'arrow-to-right']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }